/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { EditNoteParams } from 'src/florence/types/RouterState';

import EditOpNoteExtendedSurgery from './EditOpNoteExtendedSurgery';

const EditOPNoteScreen: React.FC = () => {
  const { note } = useLocation().state as EditNoteParams;

  // misc
  const navigate = useNavigate();
  if (!note) {
    navigate(-1);
  }

  return <EditOpNoteExtendedSurgery notes={[note]} />;
};

export default EditOPNoteScreen;
